import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../shared/auth.service';
import {ProfileApiService} from '../profile-api.service';

@Component({
  selector: 'submittal-feedback',
  templateUrl: './submittal-feedback.component.html',
  styleUrls: ['./submittal-feedback.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubmittalFeedbackComponent implements OnInit, OnDestroy {

  submittalFeedback = environment.flags.submittalFeedback;
  submittalFeedbackComment = environment.flags.submittalFeedbackComment;
  submittalFeedbackCount = environment.flags.submittalFeedbackCount;

  @Input() feedback: SubmittalFeedbackBody;
  @Input() submittalProfileId: string;

  helpful: boolean | null;
  comment = '';
  helpfulCountFromOthers = 0;
  masquerading$ = this.Auth.masquerading$;

  isThumbsUp$ = new BehaviorSubject(false);
  isThumbsDown$ = new BehaviorSubject(false);
  showThankYou$ = new BehaviorSubject(false);
  showComment$ = new BehaviorSubject(false);
  promptForComment$ = new BehaviorSubject(true);
  aggregateCount$ = this.isThumbsUp$.pipe(map(thumbsUp => this.helpfulCountFromOthers + (thumbsUp && 1)));

  helpfulSub = combineLatest(
    this.isThumbsUp$,
    this.isThumbsDown$,
    (thumbsUp, thumbsDown) => (!thumbsDown && !thumbsUp) ? null : thumbsUp
  ).subscribe(helpful => this.helpful = helpful);

  constructor(private Api: ProfileApiService,
              private Auth: AuthService) {
  }

  ngOnInit() {
    if (this.feedback) {
      if (this.feedback.helpful != null) {
        this.isThumbsUp$.next(this.feedback.helpful);
        this.isThumbsDown$.next(!this.feedback.helpful);
      } else {
        this.isThumbsUp$.next(false);
        this.isThumbsDown$.next(false);
      }

      this.helpfulCountFromOthers = this.feedback.helpfulCount;
    }
  }

  ngOnDestroy() {
    this.helpfulSub.unsubscribe();
  }

  thumbsUpClicked() {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.isThumbsUp$.next(!this.isThumbsUp$.getValue());
    this.showThankYou$.next(this.isThumbsUp$.getValue());
    this.isThumbsDown$.next(false);
    this.showComment$.next(false);
    this.promptForComment$.next(true);
    this.saveFeedback();
  }

  thumbsDownClicked() {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.isThumbsDown$.next(!this.isThumbsDown$.getValue());
    this.showThankYou$.next(this.isThumbsDown$.getValue());
    this.isThumbsUp$.next(false);
    this.showComment$.next(false);
    this.promptForComment$.next(true);
    this.saveFeedback();
  }

  submitComment() {
    this.saveFeedback();
    this.showComment$.next(false);
    this.promptForComment$.next(false);
    this.comment = '';
  }

  saveFeedback() {
    const feedbackUpdates = {
      helpful: this.helpful,
      comment: this.comment || null,
      helpfulCount: undefined
    };

    this.Api.saveSubmittalFeedback(this.submittalProfileId, {...this.feedback, ...feedbackUpdates}).subscribe();
  }

}
